import React, { setGlobal, addReducer, useEffect } from "reactn";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import checkIfUserIsRegisteredToApp from "shared-anpost-components/utils/checkIfUserIsRegisteredToApp";
import checkAppVersion from "shared-anpost-components/utils/checkAppVersion";

import Layout from "./_routes/Layout";
import Routes from "./_routes/Routes";
import ErrorBoundary from "./_common/error/ErrorBoundary";
import AppWrapper from "./App.styled";
import ThemeProviderStyled from "./_theme/ThemeProvider.styled";
import { StoreLocatorProvider } from "../context/Context";

let baseName = window.location.href.includes("localhost") ? window.location.pathname : "myAccount/My-deliveries";

if (window.location.href.includes("localhost")) {
    baseName = "/";
} else if (window.location.href.includes("Post-Parcels/Receiving/My-deliveries")) {
    baseName = "Post-Parcels/Receiving/My-deliveries";
}

function App() {
    useEffect(() => {
        const appRoot = document.getElementById("app-my-deliveries");

        if (appRoot) {
            const grandparent = appRoot.closest(".grid-container");

            if (grandparent) {
                grandparent.classList.remove("grid-container");
            }
        }
    }, []);

    addReducer("updateValues", (global, dispatch, valName, newVal) => ({
        values: {
            ...global.values,
            [valName]: newVal
        }
    }));

    setGlobal({
        values: {
            ciamUserId: window.ciamUID,
            delilveryMobileNumberCountryCode: "IE-353",
            personalAddressAliasOptions: [
                { id: "home", value: "Home" },
                { id: "business", value: "Business" }
            ],
            refreshMobiles: false,
            isAppV4OrHigher: checkAppVersion(appVersion => appVersion >= 4)
        },
        profile: {},
        addressObj: {},
        navData: [],
        sideNavData: [],
        callSideNav: false,
        userProfile: {},
        businessName: "",
        firstName: "",
        lastName: "",
        email: "",
        isBusiness: false,
        isCollapsed: false,
        sideNavIndex: 0,
        submenuIndex: 0,
        activeTab: "",
        businessBanner: false,
        customsBanner: false,
        mobileBanner: false,
        mobileNav: null,
        topNav: null,
        selectedTrackingItem: null,
        notOwnedItemTrackingNumber: "",
        selectedTrackingItemDetails: null,
        selectedHistoricalItem: null,
        dropSideBar: false,
        successfullApiCall: false,
        isParcelLockerFinderActive: false,
        isCollectionPointFinderActive: false,
        returnType: "receiving",
        trackingItems: [],
        refetch: false,
        userIsRegisteredToMyDelApp: checkIfUserIsRegisteredToApp("anpost_mydeliveries"),
        manageDeliveriesDropdownButtonIndexMapping: {
            1: { value: "SAFE_PLACE", label: "To a safe spot", order: 1 },
            5: { value: "POST_OFFICE", label: "To a collection point", order: 2 },
            6: { value: "POST_POINT", label: "To a collection point", order: 3 },
            8: { value: "ALTERNATIVE_DAY", label: "For another day", order: 4 },
            3: { value: "SPECIFIED_NEIGHBOUR", label: "To a neighbour", order: 5 },
            12: { value: "LOCKER", label: "To a parcel locker", order: 6 }
        }
    });

    return (
        <StoreLocatorProvider>
            <ThemeProvider theme={ThemeProviderStyled}>
                <AppWrapper>
                    <ErrorBoundary>
                        <BrowserRouter basename={baseName}>
                            <Layout>
                                <Routes />
                            </Layout>
                        </BrowserRouter>
                    </ErrorBoundary>
                </AppWrapper>
            </ThemeProvider>
        </StoreLocatorProvider>
    );
}

export default App;
